import { useLocation } from "react-router-dom"

import { ClientCallNotification } from "modules/Call/components/ClientCallNotification"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import { isClientNotificationUrl } from "app/AppRouter/utils"

export const CallNotification = () => {
    const [{ isVerified }] = useClientContext()
    const location = useLocation()
    const enabled = isVerified && isClientNotificationUrl(location.pathname)

    if (!enabled) return null
    return <ClientCallNotification />
}
